{
  "Ape 3 Hesaplama": "Ape 3 Hesaplama",
  "Takım": "Takım",
  "Yıl": "Yıl",
  "Ay": "Ay",
  "Başlangıç Tarih": "Başlangıç Tarih",
  "Taksit": "Taksit",
  "Peryot": "Peryot",
  "Ape Yüzdesi": "Ape Yüzdesi",
  "Hesapla ve Kaydet": "Hesapla ve Kaydet",
  "Kullanıcı": "Kullanıcı",
  "Ape Toplam": "Ape Toplam"
}
